import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from "@/config/routes";
import { getContactEmail } from '@/config/domains';
import propelLogo from '@/assets/propel-logo.png';
import { useToast } from "@/components/ui/use-toast";

export const Footer: React.FC = () => {
  const { toast } = useToast();
  const contactEmail = getContactEmail();
  const phone = '0300 303 1030';

  const handleEmailClick = async () => {
    try {
      await navigator.clipboard.writeText(contactEmail);
      toast({
        title: 'Email copied to clipboard',
        description: contactEmail,
      });
    } catch (error) {
      console.warn('Could not copy to clipboard:', error);
    }

    setTimeout(() => {
      window.location.href = `mailto:${contactEmail}`;
    }, 100);
  };

  return (
    <footer className="border-t bg-card px-4 py-8 text-card-foreground md:px-6 md:py-10 lg:px-8 lg:py-12">
      <div className="container-max">
        <div className="mb-8 grid grid-cols-1 gap-8 md:grid-cols-3">
          <div>
            <Link to="/" className="mb-4 flex items-center gap-2 transition-opacity hover:opacity-80">
              <div className="flex size-8 items-center justify-center overflow-hidden rounded-lg bg-primary/10">
                <img
                  src={propelLogo}
                  alt="Propel Pathways Logo"
                  className="size-6 object-contain"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <span className="text-headline text-lg font-bold">Propel Pathways</span>
            </Link>
            <p className="mb-4 text-sm text-muted-foreground">
              Empowering neurodivergent individuals through accessible career development
              and inclusive employment opportunities.
            </p>
          </div>

          <div>
            <h3 className="text-headline mb-4 font-bold">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to={ROUTES.PUBLIC_LEARNING_HUB} className="text-muted-foreground transition-colors hover:text-foreground">Learning Hub</Link></li>
              <li><Link to={ROUTES.NETWORK} className="text-muted-foreground transition-colors hover:text-foreground">Company Directory</Link></li>
              <li><Link to={ROUTES.FOR_EMPLOYERS} className="text-muted-foreground transition-colors hover:text-foreground">For Employers</Link></li>
              <li><Link to={ROUTES.EMPLOYMENT_JOURNEY} className="text-muted-foreground transition-colors hover:text-foreground">Employment Journey</Link></li>
              <li><Link to={ROUTES.PUBLIC_RESOURCE_LIBRARY} className="text-muted-foreground transition-colors hover:text-foreground">Resource Library</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-headline mb-4 font-bold">Legal & Support</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to={ROUTES.TERMS} className="text-muted-foreground transition-colors hover:text-foreground">Terms of Service</Link></li>
              <li><Link to={ROUTES.PRIVACY} className="text-muted-foreground transition-colors hover:text-foreground">Privacy Policy</Link></li>
              <li><Link to={ROUTES.COOKIES} className="text-muted-foreground transition-colors hover:text-foreground">Cookie Policy</Link></li>
              <li>
                <button
                  onClick={handleEmailClick}
                  className="text-muted-foreground transition-colors hover:text-foreground"
                >
                  Contact Support
                </button>
              </li>
              <li>
                <a href={`tel:${phone}`} className="text-muted-foreground transition-colors hover:text-foreground">{phone}</a>
              </li>
            </ul>
          </div> 
        </div>

        <div className="border-t pt-6 text-center text-sm text-muted-foreground">
          <p>&copy; 2025 Stephen Mason. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
